export { withSeoHeadTags } from "./withSeoHeadTags";
